/**
 * ModalQuantityController.jsx
 * ─────────────────────────────────────────────────────────
 * BOTTOM SECTION – Quantity selector pill.
 *
 * Renders the "–  1  +" pill as shown in the Kickers modal design.
 * The pill has a rounded border, white background, and large numerals.
 *
 * @param {object}   props
 * @param {number}   props.quantity    - Current quantity value (≥ 1)
 * @param {Function} props.onIncrease  - Called when user taps "+"
 * @param {Function} props.onDecrease  - Called when user taps "–"
 */
/* eslint-disable react/prop-types */
import React from 'react';
export default function ModalQuantityController(_ref) {
  var {
    quantity,
    onIncrease,
    onDecrease
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-qty-controller rtl:flex-row-reverse"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "modal-qty-btn modal-qty-decrease",
    onClick: onDecrease,
    disabled: quantity <= 1,
    "aria-label": "Decrease quantity"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "28",
    viewBox: "0 0 21 21",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0548 10.1379C18.0548 10.39 17.9547 10.6317 17.7765 10.8099C17.5982 10.9882 17.3565 11.0883 17.1044 11.0883H3.16524C2.91318 11.0883 2.67144 10.9882 2.49321 10.8099C2.31497 10.6317 2.21484 10.39 2.21484 10.1379C2.21484 9.88584 2.31497 9.6441 2.49321 9.46587C2.67144 9.28763 2.91318 9.1875 3.16524 9.1875H17.1044C17.3565 9.1875 17.5982 9.28763 17.7765 9.46587C17.9547 9.6441 18.0548 9.88584 18.0548 10.1379Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "modal-qty-value font-zoom-pro-normal rtl:!font-rubik"
  }, quantity), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "modal-qty-btn modal-qty-increase",
    onClick: onIncrease,
    "aria-label": "Increase quantity"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9142 16.9962C24.9142 17.2482 24.8141 17.49 24.6359 17.6682C24.4576 17.8464 24.2159 17.9466 23.9638 17.9466H17.9446V23.9658C17.9446 24.2178 17.8445 24.4596 17.6663 24.6378C17.488 24.816 17.2463 24.9162 16.9942 24.9162C16.7422 24.9162 16.5004 24.816 16.3222 24.6378C16.1439 24.4596 16.0438 24.2178 16.0438 23.9658V17.9466H10.0246C9.77256 17.9466 9.53082 17.8464 9.35258 17.6682C9.17435 17.49 9.07422 17.2482 9.07422 16.9962C9.07422 16.7441 9.17435 16.5024 9.35258 16.3241C9.53082 16.1459 9.77256 16.0458 10.0246 16.0458H16.0438V10.0266C16.0438 9.77451 16.1439 9.53277 16.3222 9.35454C16.5004 9.1763 16.7422 9.07617 16.9942 9.07617C17.2463 9.07617 17.488 9.1763 17.6663 9.35454C17.8445 9.53277 17.9446 9.77451 17.9446 10.0266V16.0458H23.9638C24.2159 16.0458 24.4576 16.1459 24.6359 16.3241C24.8141 16.5024 24.9142 16.7441 24.9142 16.9962Z",
    fill: "white"
  }))));
}